var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://www.timetap.com/ttcs/app/home/codecombat#/","frameborder":"0","width":"100%","height":"500"}})
}
var staticRenderFns = []

export { render, staticRenderFns }